import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import type { IStandingsRow } from "~src/interfaces";


const __default__ = {};

interface Props {
  standing: IStandingsRow;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'StandingLiveScore',
  props: {
    standing: {}
  },
  setup(__props: any) {

const props = __props;

const data = computed(() => {
 const liveScore = props.standing.live_score;

  if (!liveScore) {
    return null;
  }

  let scores = "";
  let isWinning = false;
  let isLosing = false;
  let isDraw = false;
  const homeScore = liveScore?.home_scores[0];
  const awayScore = liveScore?.away_scores[0];
  if (liveScore?.home_team_id === props.standing.team_id) {
    scores = liveScore.home_scores[0] + "-" + liveScore.away_scores[0];
    if (homeScore > awayScore) {
      isWinning = true;
    } else if (homeScore < awayScore) {
      isLosing = true;
    } else {
      isDraw = true;
    }
  } else if (liveScore?.away_team_id === props.standing.team_id) {
    scores = liveScore.home_scores[0] + "-" + liveScore.away_scores[0];
    if (awayScore > homeScore) {
      isWinning = true;
      scores = liveScore.away_scores[0] + "-" + liveScore.home_scores[0];
    } else if (awayScore < homeScore) {
      isLosing = true;
      scores = liveScore.away_scores[0] + "-" + liveScore.home_scores[0];
    } else {
      isDraw = true;
    }
  }

  return {
    scores,
    isWinning,
    isLosing,
    isDraw,
  };
});


return (_ctx: any,_cache: any) => {
  return (data.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["as-live-score", {
    'as-live-score--winning': data.value.isWinning,
    'as-live-score--losing': data.value.isLosing,
    'as-live-score--draw': data.value.isDraw,
  }])
      }, _toDisplayString(data.value.scores), 3))
    : _createCommentVNode("", true)
}
}

})